import { Box, CircularProgress, SxProps } from "@mui/material";
import { FC, PropsWithChildren, useContext } from "react";
import { Outlet } from "react-router-dom";
import AuthContext from "../../contexts/auth/AuthContext";
import Center from "../common/Center";
import Footer from "./Footer";
import Header from "./Header";
import { LayoutMode } from "../../enums/LayoutMode";
import { LayoutModeContext } from "../../contexts/data/LayoutContext";

const containerMapping: Record<LayoutMode, SxProps> = {
    [LayoutMode.Default]: {},
    [LayoutMode.Map]: {
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        flexDirection: 'column'
    },
    [LayoutMode.Admin]: {},
    [LayoutMode.None]: {}
}

const wrapperMapping: Record<LayoutMode, SxProps> = {
    [LayoutMode.Default]: {
        alignSelf: 'stretch',
        flex: '1 1 auto',
    
        "@media (min-width: 1300px)": {
            width: '1260px',
            height: 'auto',
            margin: '0 auto',
            overflow: 'auto'
        }
    },
    [LayoutMode.Map]: {
        alignSelf: 'stretch',
        flex: '1 1 auto',
        display: 'flex'
    },
    [LayoutMode.Admin]: {},
    [LayoutMode.None]: {}
}

const contentMapping: Record<LayoutMode, SxProps> = {
    [LayoutMode.Default]: {
        backgroundColor: 'common.white'
    },
    [LayoutMode.Map]: {
        alignSelf: 'stretch',
        flex: '1 1 auto',
        display: 'flex'
    },
    [LayoutMode.Admin]: {},
    [LayoutMode.None]: {}
}

const MyLayout: FC<PropsWithChildren> = ({ 
    children 
}) => {
    const { mode } = useContext(LayoutModeContext);

    const {loading} = useContext(AuthContext);

    if (mode === LayoutMode.None || mode === LayoutMode.Admin) {
        return children;
    }

    return (
        <Box
            sx={containerMapping[mode]}
        >
            <Header />
            <Box 
                sx={wrapperMapping[mode]}
            >
                {
                    loading ? 
                        <Center sx={{padding: "40px"}}><CircularProgress/></Center> : 
                        <>
                            <Box
                                sx={contentMapping[mode]}
                            >
                                {children}
                            </Box>
                            {mode === LayoutMode.Default && <Footer />}
                        </>
                }
            </Box>
        </Box>
    )
}

export interface ILayoutProps extends PropsWithChildren {}

const Layout: FC<ILayoutProps> = () => {

    return (
        <MyLayout>
            <Outlet />
        </MyLayout>
    )
};

export default Layout;